import { styled } from '../../../Utilities';
import { ColorSliderBase } from './ColorSlider.base';
import { getStyles } from './ColorSlider.styles';
export var ColorSlider = styled(ColorSliderBase, getStyles, undefined, { scope: 'ColorSlider' });
//# sourceMappingURL=ColorSlider.js.map